import ReactDOM from 'react-dom/client';
import React from 'react';

import { AppSettings } from './components/common/app-settings';
import { App } from './components/business/app/app';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <AppSettings>
      <App />
    </AppSettings>
  </React.StrictMode>
);
